/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import config from '@config';
import React from 'react';

/* Services */

/**
 * Renders the TopKolam component.
 *
 * @param {object} sectionContent - Content from api.
 * @returns {ReactElement} TopKolam component.
 */

const TopKolam = React.memo(({ sectionContent, margin }) => {
  const kolamTypes = {
    'ps-flower-knot': <FlowerKnot />,
    'no-decoration': <></>,
  };

  return (
    <Box
      textAlign="center"
      margin={margin || '30px 0'}
      display="flex"
      justifyContent="center"
      alignContent="center"
    >
      {kolamTypes[sectionContent.style]}
    </Box>
  );
});

const FlowerKnot = ({ ...props }) => {
  return (
    <LazyLoadImageComponent
      loading="lazy"
      width={{ base: '225px', md: '200px', lg: '470px' }} // Responsive width
      height={{ base: 'auto', md: '60px', lg: '135px' }} // Responsive height
      alt="kolam"
      title="kolam"
      src={`${config.imgPath}/d/46272/1721308187-workshopkolam.png`}
    />
  );
};

export default TopKolam;
